export enum ProcessStatusEnum {
  PENDING_SIGNATURE = 'PENDING_SIGNATURE',
  RUNNING_PENDING_REGISTRAZIONE = 'RUNNING_PENDING_REGISTRAZIONE',
  PENDING_ISSUEANDSIGN = 'PENDING_ISSUEANDSIGN',
  COMPLETED = 'COMPLETED',
}
